import _filter from 'lodash/filter'
import _pick from 'lodash/pick'

// Filter Specific QoQ
const filterQoQ = (data) => {
  return _filter(data, (o) => { return o.Quarter != 9 })
}

// Filter Specific YoY
const filterYoY = (data) => {
  return _filter(data, (o) => { return o.Quarter == 9 })
}

// Filter Fields Specific Interesting
const filterFields = (fields, data) => {
  let newData = []
  let defaultFields = ['Fiscal', 'Quarter']
  for (let i = 0; i < data.length; i++) {
    newData.push(_pick(data[i], fields.concat(defaultFields)))
  }
  return newData
}

const buildData = (fields = { enablePresent: false, qoq: [], yoy: [] }, data) => {
  // Handle unexpected data
  if (!data || !fields || !data.data || Object.keys(data.data).length === 0) {
    return false
  }
  var qoq = {}
  var yoy = {}


  // QoQ
  fields.qoq.forEach(h => {
    qoq[h] = {}
    let filtered = filterQoQ(filterFields(fields.qoq, data.data))
    filtered.forEach(e => {
      // Make Key
      let columnName = e.Quarter + 'Q' + (e.Fiscal + 543)

      // Set Value
      qoq[h][columnName] = e[h]
    })

    // Make Last Column is Present Data
    let date = data.present.Date || ''
    let keyPresentDate = formatDate(date)

    if (fields.enablePresent && keyPresentDate) {
      qoq[h][keyPresentDate] = data.present[h] || ''
    } else if (!fields.enablePresent && keyPresentDate) {
      qoq[h][keyPresentDate] = ''
    }

  })

  // YoY
  fields.yoy.forEach(h => {
    yoy[h] = {}
    let filtered = filterYoY(filterFields(fields.yoy, data.data))
    filtered.forEach(e => {
      // Make Key
      let columnName = (e.Fiscal + 543)

      // Set value
      yoy[h][columnName] = e[h]
    })

    // Make Last Column is Present Data
    let date = data.present.Date || ''
    let keyPresentDate = formatDate(date)

    if (fields.enablePresent && keyPresentDate) {//true, true
      yoy[h][keyPresentDate] = data.present[h] || ''
    } else if (!fields.enablePresent && keyPresentDate) {//false, true
      yoy[h][keyPresentDate] = ''
    }
  })
  return {
    qoq,
    yoy
  }
}

// Helper
function formatDate(date) {
  if (!date) {
    return ''
  }

  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear() + 543
  return day + '/' + month + '/' + year
}

function updateQueryString(uri, key, value) {
  let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  let separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

export {
  filterQoQ,
  filterYoY,
  filterFields,
  buildData,
  updateQueryString
}
